export const PDF_NAME = 'LUCIOLE-portfolio-RA-2026.pdf';
export const PDF_NAME_MOBILE = 'LUCIOLE-portfolio-RA-2026.pdf';
export const PDF_NAME_HR = 'LUCIOLE-portfolio-RA-2026.pdf';

export const SKIP_ANIMATION_STORAGE_KEY = 'SKIP_ANIMATION';

export const MENU_HIERARCHY = [
  { number: '', label: 'INTRODUCTION', pages: [1, 2] },
  {
    label: `DIRECTION DE L’IMMOBILIER<br> DE L’ÉTAT`,
    focusLabel: `03. DIRECTION DE L’IMMOBILIER DE L’ÉTAT`,
    number: '03',
    color: 'red',
    pages: [3, 8],
  },
  {
    label: `HÔPITAL NATIONAL DES 15-20`,
    focusLabel: `09. HÔPITAL NATIONAL DES 15-20`,
    number: '09',
    color: 'red',
    pages: [9, 10],
  },
  {
    label: `CEA`,
    focusLabel: `11. CEA`,
    number: '11',
    color: 'red',
    pages: [11, 13],
  },
  {
    label: `SOGARIS`,
    focusLabel: `14. SOGARIS`,
    number: '14',
    color: 'red',
    pages: [14, 22],
  },
  {
    label: `AGENCE DE LA BIOMÉDECINE`,
    focusLabel: `23. AGENCE DE LA BIOMÉDECINE`,
    number: '23',
    color: 'red',
    pages: [23, 27],
  },
  {
    label: `AFLD`,
    focusLabel: `28. AFLD`,
    number: '28',
    color: 'red',
    pages: [28, 31],
  },
  {
    label: `ARCEP`,
    focusLabel: `32. ARCEP`,
    number: '32',
    color: 'red',
    pages: [32, 33],
  },
  {
    label: `USH`,
    focusLabel: `34. USH`,
    number: '34',
    color: 'red',
    pages: [34, 37],
  },
  {
    label: `RETRAITE ADDITIONNELLE<br> DE LA FONCTION PUBLIQUE`,
    focusLabel: `38. RETRAITE ADDITIONNELLE DE LA FONCTION PUBLIQUE`,
    number: '38',
    color: 'red',
    pages: [38, 43],
  },
  {
    label: `CAMPUS FRANCE`,
    focusLabel: `44. CAMPUS FRANCE`,
    number: '44',
    color: 'red',
    pages: [44, 46],
  },
  {
    label: `FONDS DE RÉSERVE<br> POUR LES RETRAITES`,
    focusLabel: `47. FONDS DE RÉSERVE POUR LES RETRAITES`,
    number: '47',
    color: 'red',
    pages: [47, 49],
  },
  {
    label: `UNICANCER`,
    focusLabel: `50. UNICANCER`,
    number: '50',
    color: 'red',
    pages: [50, 52],
  },
  {
    label: `PARIS EST MARNE & BOIS`,
    focusLabel: `53. PARIS EST MARNE & BOIS`,
    number: '53',
    color: 'red',
    pages: [53, 54],
  },
  {
    label: `CAISSE DES FRANÇAIS<br> À L’ÉTRANGER`,
    focusLabel: `55. CAISSE DES FRANÇAIS À L’ÉTRANGER`,
    number: '55',
    color: 'red',
    pages: [55, 59],
  },
  {
    label: `À PROPOS DE LUCIOLE`,
    focusLabel: `60. LUCIOLE`,
    number: '60',
    color: 'red',
    pages: [60, 62],
  },
];

export const MENU_HIERARCHY_MOBILE = [
  {
    label: 'Menu',
    focusLabel: 'Menu',
    number: 'Menu',
    color: 'primary',
    pages: [1, 62],
    list: [
      { number: '', label: 'INTRODUCTION', pages: [1, 2] },
      { number: '03.', label: 'DIRECTION DE L’IMMOBILIER DE L’ÉTAT', pages: [3, 8] },
      { number: '09.', label: 'HÔPITAL NATIONAL DES 15-20', pages: [9, 10] },
      { number: '11.', label: 'CEA', pages: [11, 13] },
      { number: '14.', label: 'SOGARIS', pages: [14, 22] },
      { number: '23.', label: 'AGENCE DE LA BIOMÉDECINE', pages: [23, 27] },
      { number: '28.', label: 'AFLD', pages: [28, 31] },
      { number: '32.', label: 'ARCEP', pages: [32, 33] },
      { number: '34.', label: 'USH', pages: [34, 37] },
      { number: '38.', label: 'RETRAITE ADDITIONNELLE DE LA FONCTION PUBLIQUE', pages: [38, 43] },
      { number: '44.', label: 'CAMPUS FRANCE', pages: [44, 46] },
      { number: '47.', label: 'FONDS DE RÉSERVE POUR LES RETRAITES', pages: [47, 49] },
      { number: '50.', label: 'UNICANCER', pages: [50, 52] },
      { number: '53.', label: 'PARIS EST MARNE & BOIS', pages: [53, 54] },
      { number: '55.', label: 'CAISSE DES FRANÇAIS À L’ÉTRANGER', pages: [55, 59] },
      { number: '60.', label: 'LUCIOLE', pages: [60, 62] },
    ],
  },
];

export const SLIDES_LINKS = {
  7: 'https://ra2023-direction-immobilier-etat.fr/',
  8: 'https://ra2024-direction-immobilier-etat.fr/',
  15: 'https://ra2024.sogaris.fr/page01',
  17: 'https://ra2023.sogaris.fr/',
  24: 'https://rapport-annuel.agence-biomedecine.fr/',
  40: 'https://rafp-ra2023.fr/',
  43: 'https://rafp-ra2021.fr/',
  48: 'https://www.fondsdereserve.fr/documents/FRR-RA2023-FR.pdf',
  52: 'https://unicancer.fr/rapport-activite/2024/',
  59: 'https://www.cfe.fr/documents/310024/389309/CFE_RAPPORT-ANNUEL-2020_18x24_V5-planche.pdf',
  61: 'https://luciole.com/projets/',
};

export const MENU_DESKTOP_WIDTH = 300;
export const MENU_MOBILE_HEADER_HEIGHT = 85;
export const MENU_MOBILE_FOOTER_HEIGHT = 75;
export const NAVIGATION_HEIGHT = 52;
export const MOBILE_NAVIGATION_HEIGHT = 40;
export const PDF_PAGE_RATIO = 339 / 190;
export const MODE_SINGLE_PAGE = false;
export const TITLE_LOADER = 'LUCIOLE';
export const PRESENTATION_TEXT = 'Chez Luciole, nous donnons vie à vos rapports d\'activités en transformant chaque donnée en une histoire visuelle captivante, reflétant l\'essence unique de votre entreprise.';
export const DOWNLOAD_TEXT = 'Télécharger ce portfolio';
export const SHARE_TEXT = 'Partager ce portfolio';
export const SHARE_TEXT_FACEBOOK = 'Partager sur Facebook';
export const SHARE_TEXT_X = 'Partager sur X';
export const SHARE_TEXT_LINKEDIN = 'Partager sur LinkedIn';
export const SHARE_TEXT_COPYPASTE = 'Copier le lien dans le presse-papier';
export const SHARE_TEXT_COPYPASTE_SUCCESS = 'Lien copié dans le presse papier';

export const FOLLOW_TEXT = 'NOUS SUIVRE';

const SHARE_URL = encodeURIComponent(window.location.href);
const SHARE_DESCRIPTION = encodeURIComponent('Luciole');
const SHARE_TITLE = encodeURI('Luciole');
export const WEBSITE_URL = 'https://luciole.com/';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/agence-luciole';
export const FACEBOOK_SHARE_PARAMS = `http://www.facebook.com/share.php?u=${SHARE_URL}`;
export const X_SHARE_PARAMS = `http://x.com/intent/tweet?text=${SHARE_DESCRIPTION}&url=${SHARE_URL}`;
export const LINKEDIN_SHARE_PARAMS = ` https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}&title=${SHARE_TITLE}&summary=${SHARE_DESCRIPTION}`;

const CONFIG = {
  PDF_NAME,
  DOWNLOAD_TEXT,
  SKIP_ANIMATION_STORAGE_KEY,
  MENU_DESKTOP_WIDTH,
  MENU_MOBILE_HEADER_HEIGHT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_PAGE_RATIO,
  NAVIGATION_HEIGHT,
  MOBILE_NAVIGATION_HEIGHT,
  FACEBOOK_SHARE_PARAMS,
  X_SHARE_PARAMS,
  WEBSITE_URL,
};

export default CONFIG;
